let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8zhZ1")).then(() => parcelRequire('jeeG7'));